import { Typography } from "@mui/material";

const Invite = () => {
  return (
    
    <Typography variant="body2">Invites to create the tenant</Typography>

  );
};

export default Invite;
